<script setup>
import { computed, onMounted } from "vue";
import Loading from "./Loading.vue";

const props = defineProps({
  columns: { type: Array, required: true },
  data: { type: Array, required: true },
  loading: { type: Boolean, default: false },
});

// Função auxiliar para render condicional
const renderCell = (row, col) => {
  if (col.key === "growth") {
    return col.render ? col.render(row) : "+" + row[col.key] + "%";
  } else if (col.key === "percentage") {
    return col.render ? col.render(row) : row[col.key] + "%";
  } else {
    return col.render ? col.render(row) : row[col.key];
  }
};
</script>

<template>
  <div class="bg-white rounded-t-2xl shadow-sm overflow-x-auto">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50 divide-y divide-gray-200">
          <tr>
            <th
              v-for="(col, index) in props.columns"
              :key="index"
              class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              {{ col.title }}
            </th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-if="props.data.length === 0">
            <td :colspan="props.columns.length" class="p-6 text-center">
              Sem resultados
            </td>
          </tr>

          <tr v-else v-for="row in props.data" :key="row.id">
            <td
              v-for="(col, index) in props.columns"
              :key="index"
              :class="
                col.key === 'growth'
                  ? 'text-green-600 p-3 text-sm'
                  : 'p-3 text-sm'
              "
            >
              <!-- Coluna de ações usando slot -->
              <template v-if="col.key === 'actions' && $slots.actions">
                <slot name="actions" :row="row" />
              </template>

              <!-- Coluna padrão -->
              <template v-else>
                {{ renderCell(row, col) }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <Loading :loading-data="props.loading" />
</template>
